import {
  FETCH_INSTITUTION_ANALYTICS_ERROR,
  FETCH_INSTITUTION_ANALYTICS_REQUEST,
  FETCH_INSTITUTION_ANALYTICS_SUCCESS,
} from '../../../actions/widget/analytics/index'
import { IDLE, FETCHED, FETCHING, FAILED } from '../../../constants/fetchStates'

import {
  sunshine,
  citrus,
  tangerine,
  spice,
  cherry,
  lime,
  avocado,
  sky,
  q4Blue,
  plum
} from '../../../resources/materialui-overrides/colors'

const initialState = {
  status: IDLE,
  colors: [
    { value: sunshine },
    { value: citrus },
    { value: tangerine },
    { value: spice },
    { value: cherry },
    { value: lime },
    { value: avocado },
    { value: sky },
    { value: q4Blue },
    { value: plum }
  ]
}

const institutionWebAnalytics = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INSTITUTION_ANALYTICS_REQUEST:
      return {
        ...state,
        status: FETCHING
      }
    case FETCH_INSTITUTION_ANALYTICS_SUCCESS:
      return {
        ...state,
        items: action.payload,
        status: FETCHED
      }
    case FETCH_INSTITUTION_ANALYTICS_ERROR:
      return {
        ...state,
        error: action.error,
        status: FAILED
      }
    default:
      return state
  }
}

export default institutionWebAnalytics
